export default __webpack_public_path__ + "static/media/redExclamationMark.8c7997a8.svg";